// ./src/components/features/Forms/FormFieldsEditModal/RecaptchaEnterpriseFieldOptionsEditor.tsx
import React from "react";
import { Stack, TextInput, NumberInput, Text } from "@mantine/core";
import { RecaptchaEnterpriseOptions } from "./fieldOptionsTypes";

export interface RecaptchaEnterpriseFieldOptionsEditorProps {
  value: RecaptchaEnterpriseOptions;
  onChange: (options: RecaptchaEnterpriseOptions) => void;
}

export const RecaptchaEnterpriseFieldOptionsEditor: React.FC<
  RecaptchaEnterpriseFieldOptionsEditorProps
> = ({ value, onChange }) => {
  const handleChange = (
    field: keyof RecaptchaEnterpriseOptions,
    fieldValue: any
  ) => {
    onChange({
      ...value,
      [field]: fieldValue === "" ? undefined : fieldValue,
    });
  };

  return (
    <Stack gap="sm">
      <Text size="xs" c="dimmed">
        Configure Google reCAPTCHA Enterprise settings. These credentials are
        required for enterprise-level bot protection.
      </Text>

      <TextInput
        label="Project ID"
        placeholder="your-gcp-project-id"
        description="Google Cloud Platform project ID"
        value={value.projectId ?? ""}
        onChange={(e) => handleChange("projectId", e.target.value)}
        required
        withAsterisk
        size="sm"
      />

      <TextInput
        label="Site Key"
        placeholder="6Le..."
        description="reCAPTCHA Enterprise site key"
        value={value.siteKey ?? ""}
        onChange={(e) => handleChange("siteKey", e.target.value)}
        required
        withAsterisk
        size="sm"
      />

      <TextInput
        label="API Key"
        placeholder="AIza..."
        description="Google Cloud API key with reCAPTCHA Enterprise API enabled"
        value={value.apiKey ?? ""}
        onChange={(e) => handleChange("apiKey", e.target.value)}
        required
        withAsterisk
        size="sm"
      />

      <NumberInput
        label="Minimum Score"
        placeholder="0.5"
        description="Minimum score threshold (0.0 = bot, 1.0 = human). Recommended: 0.5"
        value={value.minScore ?? ""}
        onChange={(val) =>
          handleChange("minScore", val === "" ? undefined : val)
        }
        min={0}
        max={1}
        step={0.1}
        decimalScale={1}
        size="sm"
      />

      <TextInput
        label="Expected Action"
        placeholder="submit_form"
        description="Expected action name for score assessment"
        value={value.expectedAction ?? ""}
        onChange={(e) => handleChange("expectedAction", e.target.value)}
        size="sm"
      />
    </Stack>
  );
};
